import { Helmet } from "react-helmet-async";

function SEOComponent() {
  return (
    <Helmet>
      {/* Canonical URL */}
      <link rel="canonical" href="https://ssgfurnishing.com/" />

      {/* Open Graph Meta Tags for Social Media */}
      <meta property="og:title" content="SSG Furnishing - Luxury Home Decor" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://ssgfurnishing.com/images/og-image.jpg" />
      <meta property="og:url" content="https://ssgfurnishing.com/" />

      {/* Twitter Card Meta Tags (Optional) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="SSG Furnishing - Luxury Home Decor" />
      <meta name="twitter:image" content="https://ssgfurnishing.com/images/og-image.jpg" />

      {/* Schema.org JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FurnitureStore",
          "name": "SSG Furnishing",
          "url": "https://ssgfurnishing.com/",
          "logo": "https://ssgfurnishing.com/images/logo.png",
          "sameAs": [
            "https://www.facebook.com/ssgwindowblind",
            "https://www.instagram.com/blindsbyssg/profilecard/?igsh=YjdpbTF5czk4bnRu"
          ]
        })}
      </script>
    </Helmet>
  );
}

export default SEOComponent;
